import { APIType } from '~/backend/types';
import { useLabelingBackend } from './useBackend';

/**
 * Retrieves labeling data via the direct backend client.
 *
 * In connector mode the client's base URL is the connector's `/api` surface, so this resolves to the connector's
 * mirrored `/api/{api}/labeling` (or `/api/labeling`) endpoint — the connector forwards it to the backend. In
 * standalone mode it goes to the backend directly. Either way the request suffix mirrors the backend API, so a
 * single path serves both deployments (no separate proxied route).
 *
 * @param {APIType} apiType - The backend API type required (contouring, data, workspace, etc.)
 */
export const useLabelingData = (apiType: APIType) => {
    const { data, isLoading } = useLabelingBackend(apiType);

    return { data, isLoading };
};
